import { cn } from '@/lib/utils';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import { Smartphone, Monitor, Wifi, UserPlus } from 'lucide-react';

const METHOD_CONFIG = {
  qr: { icon: Smartphone, label: 'QR Code', color: 'text-blue-500' },
  kiosk: { icon: Monitor, label: 'Kiosk', color: 'text-purple-500' },
  nfc: { icon: Wifi, label: 'NFC', color: 'text-orange-500' },
  manual: { icon: UserPlus, label: 'Manual', color: 'text-gray-400' },
};

export function MethodIcon({ method, className, size = 'h-4 w-4' }) {
  const config = METHOD_CONFIG[method] || METHOD_CONFIG.manual;
  const Icon = config.icon;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('inline-flex items-center justify-center', className)}>
          <Icon className={cn(size, config.color)} />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{config.label}</p>
      </TooltipContent>
    </Tooltip>
  );
}
